import React from 'react'
import { Grid, Typography, Avatar } from '@mui/material'
import { format } from 'date-fns'
import Rating from '../../../ui/Rating'
import createCloudinary from '../../../../utils/createCloudinary'

const Review = ({ review }) => {
  const cld = createCloudinary()

  const studentAvatarImg = cld.image(review.studentAvatar).toURL()

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
      {review.rating !== '0' ? (
        <Grid item style={{ alignSelf: 'flex-start' }}>
          <Rating rating={Number(review.rating)} />
        </Grid>
      ) : (
        <span>{''}</span>
      )}

      <Grid item>
        <Typography variant="body1">{review.content}</Typography>
      </Grid>

      <Grid item container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Grid container alignItems="center">
            <Grid item>
              <Avatar src={studentAvatarImg} />
            </Grid>
            <Grid item>&nbsp;{review.studentName}</Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Grid container>
            <Grid item style={{ marginRight: '0.5em' }}>
              {review.isUpdated && (
                <Typography variant="body2">Đã sửa lại lần cuối lúc</Typography>
              )}
            </Grid>

            <Grid item>
              {format(new Date(review.date), 'hh:mm aa, dd-MM-yyyy')}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Review
